module.exports = __webpack_public_path__ + "static/img/weichuang-yiliao.b31fd0af.png";